/**
 *
 * Points
 *
 */

import { mapState, mapMutations, mapActions } from 'vuex';
import _ from 'lodash';
import $ from 'jquery';
import Swal from 'sweetalert2';

import { getIsWechatBrowser, getIsMobile } from '@/utils/browser';

const PayStepMixin = {
  name: 'PayStepMixin',

  computed: {
    ...mapState('Points', {
      ms_payStep: 'payStep',
    }),
  },

  methods: {
    ...mapMutations('Points', {
      mm_SET_PAY_STEP: 'SET_PAY_STEP',
    }),

    gotoStepBlank() {
      this.mm_SET_PAY_STEP('');
    },
  },

  created() {
    this.gotoStepBlank();
  },
};

const PointsGoodsListMixin = {
  name: 'PointsGoodsListMixin',

  data: () => {
    return {
      selectedGoodId: -1,
    };
  },

  computed: {
    ...mapState('Points', {
      ms_goodsList: 'goodsList',
    }),

    c_selectedGoods() {
      const goods = _.find(this.ms_goodsList, (goods) => this.selectedGoodId === goods.goodsId);
      return goods ? goods : {};
    },
  },

  methods: {
    ...mapActions('Points', {
      ma_getPointsGoodsList: 'getPointsGoodsList',
    }),

    handleClickOption(goodsId) {
      this.selectedGoodId = goodsId;
    },
  },

  created() {
    this.ma_getPointsGoodsList();
  },
};

// PayStepMixin
const YzQrcodeMixin = {
  name: 'YzQrcodeMixin',

  data: () => {
    return {
      tmotCheckYzStatus: null,
    };
  },

  computed: {
    ...mapState('Points', {
      ms_yzResultEntity: 'yzResultEntity',
      ms_pointsYzStatus: 'pointsYzStatus',
    }),

    c_isMobile() {
      return getIsMobile();
    },

    c_isWechatBrowser() {
      return getIsWechatBrowser();
    },
  },

  methods: {
    ...mapActions('Points', {
      ma_makePointsYzQrcode: 'makePointsYzQrcode',
      ma_getPointsYzStatus: 'getPointsYzStatus',
      ma_getPointsYzStatusOnce: 'getPointsYzStatusOnce',
    }),

    //
    pointsReset() {
      //
    },

    clearTmotYzQrcode() {
      clearTimeout(this.tmotCheckYzStatus);
    },

    async getPointsYzStatus() {
      await this.ma_getPointsYzStatus(this.ms_yzResultEntity.qr_id);
      if (this.ms_pointsYzStatus) {
        this.clearTmotYzQrcode();
        this.mm_SET_PAY_STEP('qrcode-succ');
        this.pointsReset();
      } else {
        this.checkYzStatusAfter4s();
      }
    },

    checkYzStatusAfter4s() {
      this.tmotCheckYzStatus = setTimeout(this.getPointsYzStatus, 4000);
    },

    checkYzStatus() {
      this.mm_SET_PAY_STEP('qrcode');
      this.checkYzStatusAfter4s();
    },

    async checkYzStatusOnce() {
      this.clearTmotYzQrcode();
      this.mm_SET_PAY_STEP('qrcode-ckecking');
      await this.ma_getPointsYzStatusOnce(this.ms_yzResultEntity.qr_id);
      if (this.ms_pointsYzStatus) {
        this.mm_SET_PAY_STEP('qrcode-succ');
        this.pointsReset();
      } else {
        this.mm_SET_PAY_STEP('qrcode-fail');
      }
    },

    async getQrCode() {
      await this.ma_makePointsYzQrcode({
        goodsId: this.selectedGoodId,
        encoreCode: '',
        code: '',
        payType: 'points',
      });
      this.checkYzStatus();
    },
  },

  beforeDestroy() {
    this.clearTmotYzQrcode();
  },
};

// PayStepMixin
const PaypalMixin = {
  name: 'PaypalMixin',

  computed: {
    ...mapState('Points', {
      ms_paypalURL: 'paypalURL',
      ms_pointsPaypalInfo: 'pointsPaypalInfo',
      ms_pointsPaypalResult: 'pointsPaypalResult',
    }),
  },

  methods: {
    ...mapMutations('Points', {
      mm_SET_IS_PAYPAL_SUBMITTING: 'SET_IS_PAYPAL_SUBMITTING',
    }),

    ...mapActions('Points', {
      ma_makePointsPaypalUrl: 'makePointsPaypalUrl',
      ma_getPointsPaypalResult: 'getPointsPaypalResult',
    }),

    //
    pointsReset() {
      //
    },

    gotoPaypalIntro() {
      this.mm_SET_PAY_STEP('paypal-intro');
    },

    beforeGotoPaypalUrl() {
      //
    },

    async gotoPaypalUrl() {
      this.beforeGotoPaypalUrl();
      this.mm_SET_IS_PAYPAL_SUBMITTING(true);
      await this.ma_makePointsPaypalUrl({
        goodsId: this.selectedGoodId,
        encoreCode: '',
        code: '',
        payType: 'points',
        limitYear: 0,
      });
      if (this.ms_paypalURL) {
        window.location.href = this.ms_paypalURL;
      } else {
        this.mm_SET_IS_PAYPAL_SUBMITTING(false);
        Swal.fire({
          width: '400px',
          backdrop: false,
          type: 'warning',
          icon: 'warning',
          title: 'paypal付款出现问题',
          showConfirmButton: true,
          timer: 2000,
        });
      }
    },

    async paypalConfirm() {
      await this.ma_getPointsPaypalResult({
        token: this.$route.query.token,
      });
      if (this.ms_pointsPaypalResult.result) {
        this.mm_SET_PAY_STEP('paypal-succ');
        this.pointsReset();
      } else {
        this.mm_SET_PAY_STEP('paypal-fail');
      }
    },
  },
};

const PayMixin = {
  name: 'PayMixin',

  mixins: [
    //
    PayStepMixin,
    PointsGoodsListMixin,
    YzQrcodeMixin,
    PaypalMixin,
  ],

  computed: {
    c_isPayDisabled() {
      return -1 === this.selectedGoodId;
    },
  },

  methods: {
    ...mapActions('Points', {
      ma_getMyPoints: 'getMyPoints',
    }),

    ///
    pointsReset() {
      this.ma_getMyPoints();
      this.selectedGoodId = -1;
    },
  },
};

export default {
  name: 'PointsGoodsModal',

  mixins: [PayMixin],

  data: () => {
    return {
      $buyPointsModal: null,
    };
  },

  methods: {
    ...mapActions('Points', {
      ma_getMyPoints: 'getMyPoints',
    }),

    show() {
      this.$buyPointsModal.modal('show');
    },

    hide() {
      this.$buyPointsModal.modal('hide');
    },

    ///
    beforeGotoPaypalUrl() {
      this.hide();
    },
  },

  mounted() {
    this.$buyPointsModal = $(this.$refs.buyPointsModal);
    this.$buyPointsModal.on('hide.bs.modal', () => {
      this.ma_getMyPoints();
    });
  },

  beforeDestroy() {
    this.hide();
  },
};
